import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withKeys as _withKeys, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "checkboxes-dropdown__toggle-label"
}
const _hoisted_2 = {
  key: 1,
  class: "checkboxes-dropdown__toggle-label"
}
const _hoisted_3 = {
  key: 0,
  class: "checkboxes-dropdown__count"
}
const _hoisted_4 = { class: "checkboxes-dropdown__content" }
const _hoisted_5 = ["id", "value", "placeholder"]
const _hoisted_6 = { class: "checkboxes-dropdown__options-list" }
const _hoisted_7 = { class: "checkbox-wrapper" }
const _hoisted_8 = ["value", "checked", "onChange"]
const _hoisted_9 = { class: "checkbox__label" }
const _hoisted_10 = { key: 0 }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", {
    ref: "target",
    class: _normalizeClass(["checkboxes-dropdown", {
			'checkboxes-dropdown--expand': $setup.show_dropdown,
			'checkboxes-dropdown--stretch': $props.stretch
		}])
  }, [
    _createElementVNode("button", {
      class: _normalizeClass(["checkboxes-dropdown__toggle", { 'checkboxes-dropdown__toggle--with-count': $props.selection && $props.selection.length}]),
      type: "button",
      onClick: _cache[0] || (_cache[0] = $event => ($setup.show_dropdown = !$setup.show_dropdown))
    }, [
      ($props.selectionLabel && $props.selection && $props.selection.length)
        ? (_openBlock(), _createElementBlock("p", _hoisted_1, [
            _createElementVNode("span", null, _toDisplayString($props.selectionLabel), 1 /* TEXT */)
          ]))
        : (_openBlock(), _createElementBlock("p", _hoisted_2, [
            _createElementVNode("span", null, _toDisplayString($props.label), 1 /* TEXT */),
            ($props.selection && $props.selection.length)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString($props.selection.length), 1 /* TEXT */))
              : _createCommentVNode("v-if", true)
          ]))
    ], 2 /* CLASS */),
    _createElementVNode("div", _hoisted_4, [
      (!$props.searchDisabled)
        ? (_openBlock(), _createElementBlock("input", {
            key: 0,
            id: $props.id,
            class: "checkboxes-dropdown__search",
            type: "text",
            value: $props.query,
            placeholder: $props.placeholder,
            onKeyup: _cache[1] || (_cache[1] = _withKeys($event => ($setup.show_dropdown = false), ["esc"])),
            onInput: $setup.handleSearch
          }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_5))
        : _createCommentVNode("v-if", true),
      _createElementVNode("ul", _hoisted_6, [
        ($props.loading)
          ? (_openBlock(), _createBlock($setup["PageLoaderComponent"], {
              key: 0,
              smaller: true
            }))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.options, (option) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: `dropdown-option-${option.value}`
                }, [
                  _createElementVNode("label", _hoisted_7, [
                    _createElementVNode("input", {
                      class: "checkbox",
                      type: "checkbox",
                      value: option.value,
                      checked: $props.selection.includes( option.value ),
                      onChange: e => $setup.handleSelection( e, option )
                    }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_8),
                    _createElementVNode("span", _hoisted_9, _toDisplayString(option.label), 1 /* TEXT */)
                  ])
                ]))
              }), 128 /* KEYED_FRAGMENT */)),
              (!$props.options || $props.options.length === 0)
                ? (_openBlock(), _createElementBlock("li", _hoisted_10, " No results "))
                : _createCommentVNode("v-if", true)
            ], 64 /* STABLE_FRAGMENT */))
      ])
    ])
  ], 2 /* CLASS */))
}